import styled from 'styled-components'

export const DummyAssignmentsContainer = styled.div`
  margin-bottom: 25px;
`
export const DummyAssignmentTouchable = styled.button`
  background-color: ${({ theme }) => theme.colors.background};
  border: none;
  cursor: pointer;
`

export const DummyAssignmentInformationContainer = styled.div`
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding-top: 15px;
  padding-bottom: 15px;
`

export const DummyAssignmentDescription = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
`
